<template>
    <!--    普通卡片-->
    <div class="container">
        <!--        <div>-->
        <el-row class="hidden-sm-and-down ordinary" v-for="(item2, index2) in hxContentList"
                :key="index2"
                :label="item2.optionTitle"
                :gutter="39"
        >

            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"
                    class="positionRight"
            >
                <!--                    <div class="grid-content" style="display: flex;justify-content: right">-->
                <!--                        <el-image :src="item2.url" class="ordinary-image"></el-image>-->
                <!--                    </div>-->
                <div class="bigDiv">
                    <!--                    <div class="zhe">-->
                    <!--                        <div style="padding:15px;background: rgb(0, 0, 0,0.1);">{{item2.title}}</div>-->
                    <!--                    </div>-->
                    <img :src="item2.url">
                    <!--                                            <el-image :src="item2.url" class="image"></el-image>-->
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="positionLeft">
                <div class="contenrtDiv">
                    <div style="height: 20%;width:100%;display: flex;justify-content: space-between;align-items: center">

                        <div style="display: flex;align-content: center;flex-direction: column;justify-content: space-around">
                            <div v-if="item2.title" style="color: #333;font-size: 18px;color: #409EFF;">
                                {{ item2.title }}
                            </div>
                            <div
                                    v-if="item2.subtitle"
                                    style=" font-size: 14px;line-height: 26px;color: #999;"
                            >
                                {{ item2.subtitle }}
                            </div>
                        </div>


<!--                        style="display: inline-block;position: absolute;right: 0px;top: 5px"-->
                        <div v-if="item2.isButton === '1'"
                             >
                            <el-button
                                    @click="jump(item2.buttonUrl)"
                                    type="primary"
                                    size="mini"

                            >{{ item2.buttonText }}
                            </el-button>

                        </div>
                    </div>
                    <div
                            class="ql-editor firstLine"
                            style="width: 100%;height: 80%;line-height: 28px;"
                            v-if="item2.content"
                            v-html="item2.content"
                    ></div>

                </div>
            </el-col>
        </el-row>
        <!--        </div>-->

        <el-row class="hidden-sm-and-up">
            <div
                    v-for="(item2, index2) in hxContentList"
                    :key="index2"
                    :label="item2.optionTitle"
            >
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div class="grid-content">
                        <el-image :src="item2.url" class="ordinary-image"></el-image>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div class="grid-content" style="margin-top: 10px">
                        <div v-if="item2.title" style="color: #333;font-size: 18px;font-weight: bold">
                            {{ item2.title }}
                        </div>
                        <div
                                v-if="item2.subtitle"
                                style=" font-size: 14px;padding: 10px 0;line-height: 26px;color: #999;"
                        >
                            {{ item2.subtitle }}
                        </div>
                        <div
                                class="about-us-content-title-content ql-editor firstLine"
                                style=""
                                v-if="item2.content"
                                v-html="item2.content"
                        ></div>
                        <div v-if="item2.isButton === '1'">
                            <el-button
                                    @click="jump(item2.buttonUrl)"
                                    type="primary"
                                    style="display: inline-block;margin-top: 10px"
                            >{{ item2.buttonText }}
                            </el-button>
                        </div>
                    </div>
                </el-col>
            </div>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "ordinary-index",
        props: {
            hxContentList: Array
        },
        methods: {
            // 按钮跳转
            jump(url) {
                window.open(url);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .bigDiv {
        position: relative;
        overflow: hidden;
        /*width: 80%;*/
        aspect-ratio: 15/8;
        /*height: 350px;*/
    }

    .positionLeft {
        display: flex;
        justify-content: left;
    }

    .positionRight {
        display: flex;
        justify-content: right;
    }

    .contenrtDiv {
        /*width: 100%;*/
        width: 100%;
        aspect-ratio: 15/8;
    }

    .scal {
        overflow: hidden;

        img {
            transition: all .3s;
        }

        &:hover img {
            transform: scale(1.1);
        }
    }

    /*首行缩进*/
    .firstLine {
        text-indent: 2em;
        line-height: 28px;
        color: #333;
        /*font-size: 12px;*/
        padding: 0

    }

    .container {
        width: 70%;
    }

    @media screen and (min-width: 1400px) {

        .container {
            width: 70%;

            /*.ordinary {*/
            /*    .ordinary-image {*/
            /*        height: 350px;*/
            /*        width: 60%;*/
            /*    }*/
            /*}*/
        }


        /*.font {*/
        /*    width: 60%;*/
        /*}*/
        .bigDiv {
            /*width: 70%;*/
        }
    }

    @media screen and (max-width: 1200px) {
        .container {
            width: 70%;
        }

        .ordinary {
            /*.ordinary-image {*/
            /*    height: 350px;*/
            /*    width: 90%;*/
            /*}*/
        }

        /*.font {*/
        /*    width: 90%;*/
        /*}*/
        .bigDiv {
            /*width: 90%;*/
        }
    }

    @media screen and (max-width: 994px) {
        .positionLeft {
            justify-content: center;
        }
        .positionRight {
            justify-content: center;
        }
    }

    @media screen and (max-width: 870px) {
        .container {
            width: 90%;
        }

        .hidden-sm-and-up {
            .ordinary-image {
                /*height: 200px;*/
                width: 100%;
            }
        }

        /*.font {*/
        /*    width: 100%;*/
        /*}*/
        .bigDiv {
            /*width: 100%;*/
        }
    }

    @media screen and (max-width: 570px) {
        .container {
            width: 90%;
        }

        .hidden-sm-and-up {
            /*.ordinary-image {*/
            /*    height: 200px;*/
            /*    width: 100%;*/
            /*}*/
        }

        /*.font {*/
        /*    width: 100%;*/
        /*}*/
        .bigDiv {
            /*width: 100%;*/
        }
    }

    .hidden-sm-and-up {
        margin: 10px 25px 0 25px;
        margin-left: unset !important;
        margin-right: unset !important;

    }

    .ordinary {
        display: flex;
        justify-content: center;
        /*height: 350px;*/
        /*width: 80%;*/
        overflow-y: hidden;
        /*margin: 10px 10px 0 10px;*/
    }

    .about-us-content-title-subtitl {
        font-size: 14px;
        line-height: 26px;
        color: #999;
    }

    .about-us-content-title-text {
        color: #333;
        font-size: 18px;
    }


    .bigDiv img {
        /*height: 100%;*/
        width: 100%;
        transition: all .3s;

        /*height: 100%;*/
    }

    .bigDiv .zhe {
        width: 100%;
        height: 100%;
        background: rgb(0, 0, 0, 0.07);
        /*background: red;*/
        position: absolute;
        top: 100%;
        transition: all .6s;
        z-index: 999;
        color: #fff;
        font-family: cursive;
        font-size: 20px;
        font-weight: 600;
        display: flex;
        flex-direction: column-reverse;
    }

    .bigDiv:hover img {
        transform: scale(1.1);
    }

    .bigDiv:hover .zhe {
        top: 0;
    }
</style>
